var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopieCodeParinageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 8.75879H10C8.89543 8.75879 8 9.65422 8 10.7588V18.7588C8 19.8634 8.89543 20.7588 10 20.7588H18C19.1046 20.7588 20 19.8634 20 18.7588V10.7588C20 9.65422 19.1046 8.75879 18 8.75879Z",
    stroke: "#5754E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.75879V6.75879C16 6.22836 15.7893 5.71965 15.4142 5.34458C15.0391 4.9695 14.5304 4.75879 14 4.75879H6C5.46957 4.75879 4.96086 4.9695 4.58579 5.34458C4.21071 5.71965 4 6.22836 4 6.75879V14.7588C4 15.2892 4.21071 15.7979 4.58579 16.173C4.96086 16.5481 5.46957 16.7588 6 16.7588H8",
    stroke: "#5754E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopieCodeParinageIcon);
export default __webpack_public_path__ + "static/media/copieCodeParinageIcon.9842edb17ade6815965ee6a210c1f722.svg";
export { ForwardRef as ReactComponent };